import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { icons, LoadingAFY, ReportScreenAFY, typeLoaders, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { useDispatch, useSelector } from "react-redux";
import { quoteAll, quoteAllClearData } from "../../store/generateQuote/actions";
import LocalStorageService from "../../services/localStorage";
import { dataColum } from "./data";
import { themeCore } from "../../assets/themes/theme";
var storageKey2 = "assurehub";
var lsLogin = new LocalStorageService(storageKey2);
export var PolicyReport = function () {
    var dispatch = useDispatch();
    var _a = useState([]), policyRows = _a[0], setPolicyRows = _a[1];
    var _b = React.useState(true), enable = _b[0], setEnable = _b[1];
    var _c = React.useState(1), page = _c[0], setPage = _c[1];
    var _d = React.useState(100), limit = _d[0], setLimit = _d[1];
    var clientId = React.useState(lsLogin.getUserLoginStored().clientId)[0];
    var _e = useSelector(function (state) { return ({
        responseAllQuote: state.Quote.responseAllQuote,
        errorAllQuote: state.Quote.errorAllQuote,
        loadingAllQuote: state.Quote.loadingAllQuote,
    }); }), responseAllQuote = _e.responseAllQuote, errorAllQuote = _e.errorAllQuote, loadingAllQuote = _e.loadingAllQuote;
    useEffect(function () {
        dispatch(quoteAllClearData());
        setPolicyRows([]);
        // window.location.reload();
    }, []);
    useEffect(function () {
        if (Array.isArray(responseAllQuote)) {
            setDataQuoteStorybook(responseAllQuote);
        }
    }, [responseAllQuote]);
    var callApi = function () {
        dispatch(quoteAll({
            clientId: clientId,
            catalogStatusQuote: "427c885d-005e-4eab-8ad3-ed1a5228e702",
            enable: enable,
            page: page,
            limit: limit,
        }));
    };
    var setDataQuoteStorybook = function (responseAllQuote) {
        var dataR = responseAllQuote === null || responseAllQuote === void 0 ? void 0 : responseAllQuote.map(function (item) {
            var _a, _b;
            return ({
                id: item.id,
                certificate: item.code,
                identification: "".concat((_a = item.identificationTypeId) === null || _a === void 0 ? void 0 : _a.description, " / ").concat(item.numberId),
                name: item.firstNameA,
                firstSurname: item.lastNameA,
                secondSurname: item.firstNameB,
                marriedName: item.lastNameB,
                quote: item.code,
                status: (_b = item.catalogStatusQuote) === null || _b === void 0 ? void 0 : _b.description,
                branch: "Principal",
                user: "User 1",
            });
        });
        setPolicyRows(dataR);
    };
    var viewReport = function () {
        callApi();
    };
    return (_jsxs(React.Fragment, { children: [_jsx(LoadingAFY, { loading: loadingAllQuote, backgroundColor: themeCore.colors.backgroundLoader, typeAnimation: typeLoaders.LogoAfy, sizeAnimation: 65, textLoading: "Cargando Pólizas.", textLoadingColor: themeCore.colors.third, spinnerColor: themeCore.colors.third }), _jsx(ReportScreenAFY, { bGColorButton: themeCore.colors.primaryText, bGColorDescriptionHelp: themeCore.colors.third, buttonTitle: "Visualizar reporte", buttonTitle2: "Generar excel", colorTitle: themeCore.colors.primaryText, columns: dataColum, descriptionHelp: "Insertar todos los campo necesarios para generar el reporte solicitado", disableButton: true, heightGrid: 575, iconColor: themeCore.colors.primaryText, iconDescription: icons.Help, onClick: function () {
                    viewReport();
                }, onClickExcel: function () { }, onClickRow: function noRefCheck() { }, rows: policyRows, title: "REPORTE DE VENTAS", titleDate1: "Fecha inicio:", titleDate2: "Fecha fin:" })] }));
};
